import React from "react";
import Lottie from "react-lottie";
import animationData from "./Download_Lottie.json";
import "./Download_Lottie.css";

function Download_Lottie(props) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="main">
      <div className="Download_Lottie_icon">
        <a
          href="https://play.google.com/store/apps/details?id=com.mobile.gravity_drive&pcampaignid=web_share"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Lottie options={defaultOptions} />
        </a>
      </div>
      {props?.successText && (
        <p className="success_text">{props.successText}</p>
      )}
    </section>
  );
}

export default Download_Lottie;
